import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建风控管理
export const CREATE_ACCOUNT_RISK_CONTROL = gql`
    mutation CreateAccountRiskControl($input: AccountRiskControlInput!) {
        createAccountRiskControl(input: $input)
    }
`;

// 更新风控管理
export const UPDATE_ACCOUNT_RISK_CONTROL = gql`
    mutation UpdateAccountRiskControl($input: AccountRiskControlInput!) {
        updateAccountRiskControl(input: $input)
    }
`;

export interface AccountRiskControlInput {
    id?: string;
    email: string;
    countryCode?: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
}

export const createAccountRiskControl = async (input: AccountRiskControlInput): Promise<boolean> => {
    const result = await client.mutate({
        mutation: CREATE_ACCOUNT_RISK_CONTROL,
        variables: { input }
    });
    return result.data.createAccountRiskControl;
};

export const updateAccountRiskControl = async (input: AccountRiskControlInput): Promise<boolean> => {
    const result = await client.mutate({
        mutation: UPDATE_ACCOUNT_RISK_CONTROL,
        variables: { input }
    });
    return result.data.updateAccountRiskControl;
};

